import { isEmpty } from "lodash";
import React, { useContext, useEffect, useMemo, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthProvider from "../../context/AuthContext";
import BetSlipContext from "../../context/BetSlipContext";
import { apiGet, apiGet2 } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import InplayTabs from "./InplayTabs";
import io from "socket.io-client";
import LayoutComponent from "../../components/shared/Layout";
import { getData, setData } from "../../Utils/indexedDB";

function Inplay() {
  const navigate = useNavigate();
  const TYPES = {
    IN_PLAY: "in_play",
    TODAY: "today",
    TOMORROW: "tomorrow",
  };
  const [type, setType] = useState(TYPES.IN_PLAY);
  const typeRef = useRef(type);

  useEffect(() => {
    typeRef.current = type; // always keep latest
  }, [type]);
  const sportsDataRef = useRef([]);
  let {
    user,
    setSearchToogle,
    setLoader,
    launchCasino,
    parly,
    setInplaySocket,
    inplaySocket,
  } = useContext(AuthProvider);
  let { handelAddMultiMarket } = useContext(BetSlipContext);
  const [loading, setLoading] = useState(false);
  const [sportsData, setSportsData] = useState([]);
  const [inPlayScore, setInPlayScore] = useState([]);
  const [socket, setSocket] = useState({});
  const [checkRefresh, setCheckRefresh] = useState(true);

  const inplayScoreSocket = async () => {
    setCheckRefresh(false);
    if (!isEmpty(socket)) {
      socket.disconnect();
    }
    if (!isEmpty(inplaySocket)) {
      inplaySocket.disconnect();
    }
    let randomId = user?.user?._id ? user?.user?._id : 112233;
    const newSocket = io(
      `${import.meta.env.VITE_SOCKET}?token=${randomId}&userType=front`,
      {
        transports: ["websocket"],
      },
    );
    setLoading(false);
    setInplaySocket(newSocket);
    setSocket(newSocket);
    const InPlayScore = (message) => {
      setInPlayScore(message);
    };
    newSocket.on("scoreAll", InPlayScore);
    newSocket.on("disconnect", function () {
      setCheckRefresh(true);
    });
    return () => newSocket.disconnect();
  };

  const transformUserInplaySportData = (newData) => {
    if (!newData) {
      return null;
    }

    // Filter out matches with negative id or eventId
    const matches = newData;

    const getGameType = (eventType) => {
      switch (eventType) {
        case 1:
          return "soccer";
        case 2:
          return "tennis";
        case 4:
          return "cricket";
        default:
          return "cricket";
      }
    };

    const transformMatches = (matchesArray) => {
      return matchesArray.map((match) => {
        const runners = match.market?.selections
          ? match.market.selections.map((selection) => ({
              SelectionId: selection.selectionId,
              RunnerName: selection.runnerName,
            }))
          : [];

        return {
          _id: match.id.toString(),
          eventId: match.eventId.toString(),
          centralizedId: match.eventId.toString(),
          eventDateTime: new Date(match.openDateTime).toISOString(),
          eventName: match.name,
          eventType: match.eventType.toString(),
          gameType: getGameType(match.eventType),
          marketCount: match.markets ? match.markets.length : 0,
          marketId: match.market ? match.market.marketId : "",
          seriesId: match.competitionId.toString(),
          seriesName: match.competitionName,
          status: match.isInPlay === 1 ? "in_play" : "upcoming",
          timeZone: match.timezone || "GMT",
          runners,
          premiumFancy:
            match.hasSportsBookMarkets ||
            match.hasOwSportsBookMarkets ||
            match.hasGeniusSportsMarkets
              ? "on"
              : "off",
          bookMaker:
            match.hasBookMakerMarkets || match.hasInPlayBookMakerMarkets
              ? "on"
              : "off",
          fancy:
            match.hasFancyBetMarkets || match.hasInPlayFancyBetMarkets
              ? "on"
              : "off",
        };
      });
    };

    return {
      success: newData.status,
      message: newData.message,
      results: transformMatches(matches), // single bucket
    };
  };

  const fetchAllSport = async (isLoader = true) => {
    // if (isLoader) {
    //   setLoader(true);
    // }

    let temp = user ? `&userId=${user.user._id}` : "";
    let parlyType = parly ? `&pagetype=multi` : "";

    const currentType = typeRef.current;

    // ✅ 1. Load from IndexedDB FIRST
    const storedData = await getData("sportsData");

    if (storedData) {
      try {
        if (storedData?.status) {
          setLoader(false);
          setLoading(false);
          appendData(currentType, storedData); // 🔥 instant UI
        }
      } catch (e) {
        console.error("Invalid localStorage data");
      }
    }

    // ✅ 2. Call API in background
    try {
      const { status, data: response_users } = await apiGet(
        apiPath.matchList + `?game_type=all`,
      );

      if (status === 200 && response_users.status) {
        // ✅ 3. Save in IndexedDB
        await setData("sportsData", response_users);

        // ✅ 4. Update UI with fresh data
        appendData(currentType, response_users);
      }
    } catch (err) {
      console.error(err);
    }

    setLoading(false);
    setLoader(false);
  };
  const appendData = async (type, storedData) => {
    const matches = storedData?.data?.matches || [];

    // ✅ filter by type
    let filteredMatches =
      type && type !== "all" ? matches.filter((m) => m.type === type) : matches;
    // Transform new data format to old format
    const transformedData = transformUserInplaySportData(filteredMatches);
    let newData = transformedData.results || [];

    // Sort matches by eventDateTime, but push Virtual competitions to the bottom
    newData = newData.sort((a, b) => {
      const aVirtual = a.seriesName?.toLowerCase().includes("virtual");
      const bVirtual = b.seriesName?.toLowerCase().includes("virtual");

      if (aVirtual !== bVirtual) return aVirtual ? 1 : -1;

      return (
        new Date(a.eventDateTime).getTime() -
        new Date(b.eventDateTime).getTime()
      );
    });

    setSportsData((prevData = []) => {
      const prevMap = new Map(
        prevData.map((item) => [String(item.eventId), item]),
      );

      // ✅ Convert score to map (O(n))
      const scoreMap = new Map(
        (inPlayScore || []).map((s) => [String(s.eventId), s]),
      );

      return newData.map((item) => {
        const existing = prevMap.get(String(item.eventId));
        const score = scoreMap.get(String(item.eventId));

        return {
          ...item,

          // ✅ Preserve odds
          ...(existing && {
            back_odds: existing.back_odds,
            lay_odds: existing.lay_odds,
            totalMatched: existing.totalMatched,
            matchOddsData: existing.matchOddsData,
          }),

          // ✅ Add score
          score: score?.score && score.score !== 0 ? score.score : "",
          timeElapsed: score?.timeElapsed || "",
        };
      });
    });
    setLoader(false);
  };
  const transformMatchDataToOldFormat = (newData) => {
    if (!newData || !newData.data || !Array.isArray(newData.data)) {
      return null;
    }

    // Transform all market data entries
    const transformedMarkets = newData.data.map((marketData) => {
      const msValue =
        marketData.status === "OPEN"
          ? 1
          : marketData.status === "SUSPENDED"
            ? 3
            : 1;

      const runners = marketData.selections.map((selection) => ({
        selectionId: selection.selectionId,
        handicap: selection.handicap,
        status: selection.status,
        lastPriceTraded: selection.lastPriceTraded,
        totalMatched: selection.totalMatched,
        adjustmentFactor: 0,
        ex: {
          availableToBack:
            selection.availableToBack.length > 0
              ? selection.availableToBack
              : [
                  { price: 0, size: 0 },
                  { price: 0, size: 0 },
                  { price: 0, size: 0 },
                ],
          availableToLay:
            selection.availableToLay.length > 0
              ? selection.availableToLay
              : [
                  { price: 0, size: 0 },
                  { price: 0, size: 0 },
                  { price: 0, size: 0 },
                ],
        },
      }));

      let rt = [];

      marketData.selections.forEach((selection) => {
        if (selection.availableToBack && selection.availableToBack.length > 0) {
          selection.availableToBack.forEach((back) => {
            rt.push({
              ri: selection.selectionId,
              rt: back.price,
              bv: back.size,
              ib: true,
            });
          });
        } else {
          for (let i = 0; i < 3; i++) {
            rt.push({
              ri: selection.selectionId,
              rt: 0,
              bv: 0,
              ib: true,
            });
          }
        }

        if (selection.availableToLay && selection.availableToLay.length > 0) {
          selection.availableToLay.forEach((lay) => {
            rt.push({
              ri: selection.selectionId,
              rt: lay.price,
              bv: lay.size,
              ib: false,
            });
          });
        } else {
          for (let i = 0; i < 3; i++) {
            rt.push({
              ri: selection.selectionId,
              rt: 0,
              bv: 0,
              ib: false,
            });
          }
        }
      });

      return {
        mi: marketData.marketId,
        ms: msValue,
        totalMatched: marketData.totalMatched,
        rt: rt,
        runners: runners,
        lastMatchTime: marketData.lastMatchTime,
        ts: new Date().toISOString().replace("T", " ").substring(0, 19),
        eventId: marketData.eventId,
        eventType: marketData.eventType,
      };
    });

    return {
      success: newData.status,
      message: newData.message,
      results: transformedMarkets,
    };
  };

  const transformMarketForEvent = (marketData) => {
    if (!marketData) return null;

    const msValue =
      marketData.status === "OPEN"
        ? 1
        : marketData.status === "SUSPENDED"
          ? 3
          : 1;

    const runners = marketData.selections.map((selection) => ({
      selectionId: selection.selectionId,
      handicap: selection.handicap,
      status: selection.status,
      lastPriceTraded: selection.lastPriceTraded,
      totalMatched: selection.totalMatched,
      adjustmentFactor: 0,
      ex: {
        availableToBack:
          selection.availableToBack.length > 0
            ? selection.availableToBack
            : [
                { price: 0, size: 0 },
                { price: 0, size: 0 },
                { price: 0, size: 0 },
              ],
        availableToLay:
          selection.availableToLay.length > 0
            ? selection.availableToLay
            : [
                { price: 0, size: 0 },
                { price: 0, size: 0 },
                { price: 0, size: 0 },
              ],
      },
    }));

    let rt = [];

    marketData.selections.forEach((selection) => {
      if (selection.availableToBack && selection.availableToBack.length > 0) {
        selection.availableToBack.forEach((back) => {
          rt.push({
            ri: selection.selectionId,
            rt: back.price,
            bv: back.size,
            ib: true,
          });
        });
      } else {
        for (let i = 0; i < 3; i++) {
          rt.push({
            ri: selection.selectionId,
            rt: 0,
            bv: 0,
            ib: true,
          });
        }
      }

      if (selection.availableToLay && selection.availableToLay.length > 0) {
        selection.availableToLay.forEach((lay) => {
          rt.push({
            ri: selection.selectionId,
            rt: lay.price,
            bv: lay.size,
            ib: false,
          });
        });
      } else {
        for (let i = 0; i < 3; i++) {
          rt.push({
            ri: selection.selectionId,
            rt: 0,
            bv: 0,
            ib: false,
          });
        }
      }
    });

    return {
      mi: marketData.marketId,
      ms: msValue,
      totalMatched: marketData.totalMatched,
      rt: rt,
      runners: runners,
      lastMatchTime: marketData.lastMatchTime,
      ts: new Date().toISOString().replace("T", " ").substring(0, 19),
      eventId: marketData.eventId,
      eventType: marketData.eventType,
    };
  };

  const getMatchOdds = async (eventIds) => {
    if (!eventIds || eventIds.length === 0) return;

    try {
      const { status, data: response } = await apiGet2(
        apiPath.getMatchOdds + `?match_ids=${eventIds.join(",")}`,
      );

      if (status === 200 && response.status && response.data) {
        // Create a map of eventType from current sportsData
        const eventTypesMap = {};
        sportsDataRef.current?.forEach((item) => {
          eventTypesMap[item.eventId] = item.eventType;
        });

        // Group markets by eventId
        const marketsByEvent = {};
        response.data.forEach((market) => {
          if (!marketsByEvent[market.eventId]) {
            marketsByEvent[market.eventId] = [];
          }
          marketsByEvent[market.eventId].push(market);
        });

        // Transform each event's market data
        const transformedByEvent = {};
        Object.keys(marketsByEvent).forEach((eventId) => {
          const markets = marketsByEvent[eventId];
          const eventType = eventTypesMap[eventId];

          // For soccer (eventType 1), if there are multiple markets, use only the first one
          let marketToUse;
          if (eventType === 1 && markets.length > 1) {
            marketToUse = markets[0];
          } else {
            marketToUse = markets[0];
          }

          transformedByEvent[eventId] = transformMarketForEvent(marketToUse);
        });

        const transformedMarkets = Object.values(transformedByEvent).filter(
          (m) => m !== null,
        );

        if (transformedMarkets && transformedMarkets.length > 0) {
          setSportsData((current) =>
            current?.map((obj) => {
              // Find the matching market data for this event
              const socket_data = transformedMarkets.find(
                (market) => String(market.eventId) === String(obj.eventId),
              );

              if (socket_data) {
                const back_odds = socket_data?.rt?.filter((rt) => rt.ib) || [];
                const lay_odds = socket_data?.rt?.filter((rt) => !rt.ib) || [];
                return {
                  ...obj,
                  back_odds,
                  lay_odds,
                  totalMatched: socket_data?.totalMatched,
                  matchOddsData: socket_data,
                };
              }
              return obj;
            }),
          );
        }
      }
    } catch (error) {
      console.error("Error fetching match odds:", error);
    }
  };

  useEffect(() => {
    sportsDataRef.current = sportsData;
  }, [sportsData]);

  useEffect(() => {
    if (!loading) return;

    fetchAllSport();
    inplayScoreSocket(); // ✅ only once here
  }, [loading]);

  useEffect(() => {
    if (!inPlayScore?.length) return;

    const scoreMap = new Map(inPlayScore.map((item) => [item.eventId, item]));

    setSportsData((current) =>
      current.map((res) => {
        const temp = scoreMap.get(res.eventId);

        return {
          ...res,
          score: temp?.score && temp.score !== 0 ? temp.score : "",
          timeElapsed: temp?.timeElapsed || "",
        };
      }),
    );
  }, [inPlayScore]);

  useEffect(() => {
    if (checkRefresh) {
      inplayScoreSocket();
    }
  }, [checkRefresh]);

  useEffect(() => {
    const loadFromDB = async () => {
      // setLoader(true);

      const stored = await getData("sportsData");

      if (stored?.status) {
        appendData(type, stored);
      }
    };

    loadFromDB();
  }, [type]);

  useEffect(() => {
    let isFetching = false;

    const callApi = async () => {
      if (isFetching || document.hidden) return;

      isFetching = true;
      await fetchAllSport(false);
      isFetching = false;
    };

    callApi();

    const interval = setInterval(callApi, 60000);

    return () => clearInterval(interval);
  }, []);

  // Polling for match odds - runs every 5 seconds
  const hasDataRef = useRef(false);
  const pollingRef = useRef(null);

  // useEffect(() => {
  //   const poll = () => {
  //     const currentData = sportsDataRef.current;

  //     if (!currentData || currentData.length === 0) return;

  //     const eventIds = currentData
  //       .map(item => item.eventId)
  //       .filter(id => id);

  //     if (eventIds && eventIds.length > 0) {
  //       getMatchOdds(eventIds);
  //     }
  //   };

  //   // run immediately when sportsData first becomes available
  //   if (sportsData && sportsData.length > 0 && !hasDataRef.current) {
  //     hasDataRef.current = true;
  //     poll();
  //   }

  //   // start interval only once
  //   if (!pollingRef.current) {
  //     pollingRef.current = setInterval(poll, 15000);
  //   }

  //   return () => {
  //     clearInterval(pollingRef.current);
  //     pollingRef.current = null;
  //   };
  // }, [sportsData]);

  document.addEventListener("visibilitychange", function () {
    if (!document.hidden && !checkRefresh) {
      if (!isEmpty(socket)) {
        socket.disconnect();
      }
      setCheckRefresh(true);
    } else {
      setCheckRefresh(false);
    }
  });
  return (
    <>
      <LayoutComponent visibilityType={true}>
        <div className="mian-wrap">
          <div className="tab-wrap">
            <ul>
              <li
                id="inplay"
                className={type == "in_play" ? "select" : ""}
                onClick={() => {
                  setType(TYPES.IN_PLAY);
                }}
              >
                <a href="javascript:void(0)" neua="In-Play">
                  In-Play
                </a>
              </li>
              <li
                id="today"
                className={type == "today" ? "select" : ""}
                onClick={() => {
                  setType(TYPES.TODAY);
                }}
              >
                <a href="javascript:void(0)">Today</a>
              </li>
              <li
                id="tomorrow"
                className={type == "tomorrow" ? "select" : ""}
                onClick={() => {
                  setType(TYPES.TOMORROW);
                }}
              >
                <a href="javascript:void(0)">Tomorrow</a>
              </li>
              <li id="result">
                <Link to={isEmpty(user) ? "/login" : "/result"}>Result</Link>
              </li>
            </ul>
            <a
              className="a-search"
              onClick={() => setSearchToogle(true)}
              href="javascript:void(0)"
            >
              Search
            </a>
          </div>
          {/* {console.log(sportsData)} */}
          {sportsData && sportsData.length > 0 && (
            <>
              {sportsData?.filter((res) => res.gameType == "cricket")?.length >
                0 && (
                <InplayTabs
                  type={type}
                  parlyTab={parly}
                  data={sportsData || []}
                  handelAddMultiMarket={handelAddMultiMarket}
                  setLoading={setLoading}
                  sportsType={"Cricket"}
                  sportsId={4}
                />
              )}
              {/* <div id="inplayVirtualCricketImage" className="footer-kv">
              <a
                id="inplayVirtualCricketEntrance"
                className="entrance"
                onClick={() => {
                  if (!isEmpty(user)) {
                    //
                    launchCasino({
                      platForm: "SABA",
                      gameType: "VIRTUAL",
                      casinoType: "SABA-VIRTUAL-001",
                    });
                  } else {
                    navigate("/login");
                  }
                }}
              >
                <img
                  src="assets/images/kv-virtual-cricket-m.jpg"
                  style={{ width: "100%" }}
                />
              </a>
            </div> */}
              {sportsData?.filter((res) => res.gameType == "soccer")?.length >
                0 && (
                <InplayTabs
                  type={type}
                  parlyTab={parly}
                  data={sportsData || []}
                  handelAddMultiMarket={handelAddMultiMarket}
                  setLoading={setLoading}
                  sportsType={"Soccer"}
                  sportsId={1}
                />
              )}
              {sportsData?.filter((res) => res.gameType == "tennis")?.length >
                0 && (
                <InplayTabs
                  type={type}
                  parlyTab={parly}
                  data={sportsData || []}
                  handelAddMultiMarket={handelAddMultiMarket}
                  setLoading={setLoading}
                  sportsType={"Tennis"}
                  sportsId={2}
                />
              )}
            </>
          )}
        </div>
      </LayoutComponent>
    </>
  );
}

export default Inplay;
